import { createContext, FC, TableHTMLAttributes, useContext } from 'react';

export const TableHeadContext = createContext(false);

export const useIsTableHead = () => useContext(TableHeadContext);

export const Table: FC<TableHTMLAttributes<HTMLTableElement>> = ({ className, children, ...props }) => (
  <table className={['w-full border-collapse text-left text-sm', className].filter(Boolean).join(' ')} {...props}>
    {children}
  </table>
);
